import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textXSObj } = typographyStyles;

export const rootCss = {
  padding: "20px 16px 16px",
};

export const questionCountContainerCss = {
  ...textXSObj,
  letterSpacing: "1px",
  color: colors.ui.neutral[400],
  textTransform: "uppercase",
  margin: "24px 0 0 0",
};
